export default {
  app: {
    privacy: {
      policy: 'polityka prywatności',
      expansive: 'Korzystając z Expansive, akceptujesz {action} Expansive',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Sesja wygasła',
    sessionExpiredDescription:
      'Twoja sesja wygasła. Zaloguj się ponownie, aby kontynuować korzystanie z aplikacji.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Wybierz język',
      chooseLanguageDescription:
        'Wybierz preferowany język aplikacji. Zmieni to język interfejsu i treści.',
    },
    userSelection: {
      cancel: 'Anuluj',
      createNewUser: 'Nie ma ich na liście',
      newUser: 'Nowy użytkownik',
      selectAnExistingUser: 'Wybierz istniejącego użytkownika',
      selectUserHint: 'Wybierz istniejącego użytkownika lub utwórz nowego, aby kontynuować.',
      startTypingToSearch: 'Zacznij pisać...',
    },
    verification: {
      codeVerification: {
        continue: 'Kontynuuj',
        header: 'Wprowadź kod dostępu do obiektu',
        invalidCode: 'Nieprawidłowy kod, spróbuj ponownie.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Kontynuuj bez weryfikacji lokalizacji',
        enterSiteAccessCode: 'Wprowadź kod dostępu do obiektu',
        locationNotEnabledOrAvailable: 'Dlaczego widzę to?',
        notAvailable: {
          description: 'Lokalizacja GPS nie jest obsługiwana na tym urządzeniu.',
          header: 'Lokalizacja nie jest obsługiwana',
        },
        notEnabled: {
          description: 'Usługi lokalizacji nie są włączone lub nie udzielono zgody.',
          header: 'Lokalizacja nie jest włączona',
        },
        notVerified: {
          description: 'GPS wskazuje, że nie jesteś na miejscu.',
          header: 'Lokalizacja niezweryfikowana',
        },
        tryAgain: 'Spróbuj ponownie',
        unavailable: {
          description: 'Nie udało się zweryfikować Twojej lokalizacji GPS.',
          header: 'Lokalizacja niedostępna',
        },
        unknown: {
          description: 'Nie możemy określić Twojej lokalizacji.',
          header: 'Nieznana lokalizacja',
        },
        verified: {
          description: 'GPS wskazuje, że jesteś na miejscu.',
          header: 'Lokalizacja zweryfikowana',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Nie znaleziono zasobów',
        emptyDescription: 'Brak zasobów powiązanych z tym zleceniem.',
        warrantyParts: 'Gwarancja części wygasa',
        serialNumber: 'Numer seryjny',
        none: '<brak>',
      },
      updates: {
        emptyTitle: 'Brak aktualizacji',
        emptyDescription: 'Brak aktualizacji dla tego zlecenia.',
        unknownUser: 'Nieznany użytkownik',
        none: 'Brak',
        addComment: {
          buttonLabel: 'Dodaj komentarz',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Zagrożenia',
          no: 'Nie',
          yes: 'Tak',
        },
      },
    },
    attachmentsList: {
      attachments: 'Załączniki',
      documents: 'Dokumenty',
      siteDocuments: 'Dokumenty obiektu',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Zagrożenia',
        induction: 'Instruktaż',
        safeToProceed: 'Można kontynuować',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Termin wykonania',
        activeSessions: 'Aktywne sesje',
        activeSessionsDescription:
          'Jesteś już zalogowany do następujących zleceń. Musisz się z nich wylogować przed zalogowaniem do nowego zlecenia.',
        resumeSession: 'Wznów',
        startTime: 'Rozpoczęto o',
        unexpectedErrorTitle: 'Nieoczekiwany błąd',
        unexpectedErrorMessage:
          'Wystąpił nieoczekiwany błąd podczas tworzenia sesji. Spróbuj ponownie później.',
        engineerNotFound: 'Nie znaleziono inżyniera',
        engineerNotFoundDescription:
          'Inżynier, którego próbujesz zalogować, nie został znaleziony w systemie. Skontaktuj się z administratorem.',
      },
      verification: {
        code: {
          description:
            'Aby się zameldować, uzyskaj 4-cyfrowy kod od kierownika obiektu lub wyznaczonej osoby.',
        },
        geo: {
          continue: 'Kontynuuj',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Uzyskaj kod dostępu od kierownika placówki lub wyznaczonego kontaktu, aby zakończyć wizytę.',
            checkOut: 'Wymelduj się',
            completeBeforeLeaving: 'Wypełnij poniższy formularz przed opuszczeniem obiektu.',
            continue: 'Kontynuuj',
            noResolutionSelected: 'Wybierz rozwiązanie przed kontynuacją.',
            quoteRequired: {
              hint: 'Wizyta zakończona, wycena wkrótce',
              label: 'Wymagana wycena',
            },
            returnVisitRequired: {
              hint: 'Wrócimy ponownie, aby dokończyć',
              label: 'Wymagana ponowna wizyta',
            },
            serviceCompleted: {
              hint: 'Nie są wymagane dalsze działania',
              label: 'Usługa zakończona',
            },
            uploadCheckout: 'Prześlij plik, zdjęcie lub wideo',
            visitNotes: 'Notatki z wizyty',
            workOrderResolution: 'Rozwiązanie zlecenia',
            enterNotes: 'Wpisz notatki tutaj...',
            errors: {
              timedOut: 'Limit czasu przekroczony, ponad 30 sekund. Spróbuj ponownie.',
              closingSession: 'Błąd zamykania sesji',
            },
          },
          success: {
            description:
              'Dziękujemy za wizytę w {site}. | {site} ma jeszcze 1 otwarte zlecenie. | {site} ma jeszcze {count} otwartych zleceń.',
            endVisit: 'Zakończ wizytę',
            header: 'Pomyślnie się wymeldowałeś',
            viewWorkOrders: 'Zamelduj się do innego zlecenia',
          },
          verification: {
            code: {
              description:
                'Aby się wymeldować, uzyskaj 4-cyfrowy kod od kierownika obiektu lub wyznaczonej osoby.',
              continue: 'Kontynuuj',
            },
            geo: {
              checkOut: 'Wymelduj się',
              continue: 'Kontynuuj',
            },
          },
        },
        detail: {
          assets: 'Zasoby',
          call: 'Zadzwoń',
          checkOut: 'Wymelduj się',
          closed: 'Zamknięte',
          details: 'Szczegóły',
          dueBy: 'Termin wykonania',
          manageEngineers: 'Zarządzaj inżynierami',
          notAvailable: 'Niedostępne',
          pointOfContact: 'Osoba kontaktowa',
          siteAccessTimes: 'Godziny dostępu do obiektu',
          siteAccessInstructions: 'Instrukcje dostępu',
          siteAddress: 'Adres obiektu',
          siteNotes: 'Notatki obiektu',
          siteTelephone: 'Telefon obiektu',
          siteLocation: 'Lokalizacja obiektu',
          updates: 'Aktualizacje',
          more: 'Więcej',
          mismatchErrorTitle: 'Błąd zlecenia',
          mismatchErrorMessage:
            'Zlecenie, do którego próbujesz uzyskać dostęp, nie zgadza się z tym, do którego jesteś obecnie zalogowany. Sprawdź zlecenie i spróbuj ponownie.',
          siteDocuments: 'Dokumenty obiektu',
          validFrom: 'Ważne od',
          validUntil: 'Ważne do',
          documentName: 'Nazwa dokumentu',
          documentType: 'Typ dokumentu',
          attachments: 'Pliki zlecenia',
          download: 'Pobierz',
          workDetails: 'Szczegóły pracy',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Dodaj asystenta inżyniera',
            assistantEngineers: 'Asystenci inżyniera',
            description:
              'Ze względów bezpieczeństwa podaj imiona wszystkich inżynierów na miejscu.',
            editMainEngineer: 'Edytuj głównego inżyniera',
            errors: {
              creatingEngineer: 'Błąd tworzenia inżyniera',
              creatingSession: 'Błąd tworzenia sesji',
            },
            header: 'Inżynierowie na miejscu',
            mainEngineer: 'Główny inżynier',
            newAssistantEngineer: 'Wpisz ich pełne imię i nazwisko',
            next: 'Dalej',
            removeEngineer: 'Usuń inżyniera',
            selectExistingAssistantEngineer: 'Zacznij wpisywać ich imię',
          },
          index: {
            description:
              'Ze względów bezpieczeństwa podaj imiona wszystkich inżynierów na miejscu.',
            errorCreatingEngineer: 'Błąd tworzenia inżyniera, spróbuj ponownie.',
            header: 'Inżynierowie na miejscu',
            hintMainEngineer: 'Wpisz pełne imię i nazwisko głównego inżyniera',
            newMainEngineer: 'Nowy główny inżynier',
            next: 'Dalej',
            selectExistingMainEngineer: 'Wybierz istniejącego głównego inżyniera',
            yes: 'Tak',
            no: 'Nie',
            mainEngineerLabel: 'Czy jesteś głównym inżynierem?',
          },
        },
        index: {
          callUsOn: 'Zadzwoń do nas pod {phoneNumber}',
          description: 'Nie możesz znaleźć tego, czego szukasz?',
          dueBy: 'Termin wykonania',
          header: 'Wybierz zlecenie',
          notAvailable: 'Niedostępne',
          searchWorkOrders: 'Szukaj zleceń...',
        },
        manageEngineers: {
          manageEngineers: 'Zarządzaj inżynierami',
          notWorking: 'Nieaktywni pracownicy',
          pause: 'Wstrzymaj',
          resume: 'Wznów',
          workingNow: 'Aktywni pracownicy',
          startTime: 'Czas rozpoczęcia',
          endTime: 'Czas zakończenia',
          duration: 'Czas trwania',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Opinia',
            feedbackDescription:
              'Prosimy o opinię na temat zlecenia, abyśmy mogli ulepszyć nasze usługi.',
            feedbackLabel: 'Opinia',
            filesLabel: 'Załączniki',
            submissionLabel: 'Prześlij opinię',
          },
          hazards: {
            back: 'Wróć',
            hazards: 'Zagrożenia',
            next: 'Dalej',
            no: 'Nie',
            noTasksForHazard: 'Brak zadań do wykonania dla tego zagrożenia.',
            yes: 'Tak',
          },
          induction: {
            continue: 'Kontynuuj',
            induction: 'Instruktaż',
          },
          index: {
            checkIn: 'Zamelduj się',
            description: 'Wypełnij poniższą ocenę ryzyka dla wybranego zlecenia.',
            fail: 'Nie udało się przetworzyć kontroli rozpoczęcia pracy.',
            haltMessage:
              'Wykryto potencjalne zagrożenia. Zatrzymaj pracę, zapoznaj się z wytycznymi BHP i skontaktuj się z przełożonym.',
            header: 'Kontrole rozpoczęcia pracy',
            endVisit: 'Zakończ wizytę',
            leaveFeedback: 'Zostaw opinię',
          },
          safeToProceed: {
            continue: 'Kontynuuj',
            safeToProceed: 'Można kontynuować',
          },
        },
      },
    },
    index: {
      title: 'Witamy',
      description: 'Zeskanuj kod QR w swojej lokalizacji, aby rozpocząć.',
    },
    login: {
      errorTitle: 'Nieoczekiwany błąd',
      errorMessage: 'Wystąpił nieoczekiwany błąd. Spróbuj ponownie zeskanować kod QR.',
    },
    unauthenticated: {
      welcome: {
        title: 'Witamy w {site}',
        description:
          'Zanim pokażemy Ci zlecenia, musimy zweryfikować Twoje dane. Kliknij przycisk poniżej, aby kontynuować.',
        next: 'Kontynuuj',
      },
      index: {
        errorTitle: 'Nieoczekiwany błąd',
        errorMessage: 'Wystąpił nieoczekiwany błąd. Spróbuj ponownie zeskanować kod QR.',
      },
      contractor: {
        title: 'Dla kogo pracujesz?',
        contractor: 'Wykonawca',
        contractorLabel: 'Zacznij wpisywać nazwę firmy',
        contractorHint: 'Musisz wpisać co najmniej 3 znaki, aby zobaczyć wyniki',
        defaultSelectPlaceholder: '--Wybierz--',
        next: 'Dalej',
      },
      user: {
        title: 'Kim jesteś?',
        cancel: 'Anuluj',
        createNewUserLabel: 'Nie ma mnie na liście',
        existingUserLabel: 'Zacznij wpisywać swoje imię',
        existingUserHint: 'Musisz wpisać co najmniej 3 znaki, aby zobaczyć wyniki',
        newUserLabel: 'Wpisz swoje pełne imię i nazwisko',
        next: 'Dalej',
        user: 'Użytkownik',
      },
      verification: {
        methods: {
          add: {
            add: 'Dodaj metodę weryfikacji',
            defaultSelectPlaceholder: '--Wybierz--',
            emailLabel: 'E-mail',
            existingMethodWarning:
              'Masz już oczekujące żądanie tej metody weryfikacji do zatwierdzenia przez administratora. Dodanie nowej zastąpi poprzednią.',
            method: 'Metoda',
            methodLabel: 'Metoda',
            mobileCountryHint: 'Wybierz kod kraju',
            mobileCountryLabel: 'Kod kraju telefonu',
            mobileHint: 'Wpisz numer telefonu',
            mobileLabel: 'Telefon',
            title: 'Dodaj metodę weryfikacji',
          },
          confirm: {
            confirm: 'Potwierdź',
            description: 'Potwierdź metodę weryfikacji, aby kontynuować.',
            label: 'Wpisz kod',
            resend: 'Wyślij ponownie',
            resendPrompt: 'Nie otrzymałeś kodu?',
            title: 'Potwierdź metodę weryfikacji',
          },
          confirmed: {
            description:
              'Zostaniesz powiadomiony, gdy ta metoda weryfikacji zostanie zatwierdzona przez administratora i będziesz mógł jej używać do weryfikacji tożsamości.',
            forceApproval: 'Dopóki nie zostanie zatwierdzona, nie masz dostępu do zleceń.',
            nonForceApproval: 'W międzyczasie możesz korzystać ze zleceń z ograniczonym dostępem.',
            nonForceApprovalButtonLabel: 'Kontynuuj z ograniczonym dostępem',
            title: 'Oczekiwanie na zatwierdzenie',
          },
          addNew: 'Dodaj nową metodę weryfikacji',
          description: 'Musimy zweryfikować Twoją tożsamość, aby dać Ci pełny dostęp do zlecenia.',
          email: 'E-mail',
          hint: 'Wyślemy link do wybranej metody weryfikacji, który da Ci pełny dostęp do zlecenia. Jeśli chcesz zmienić istniejące metody, skontaktuj się z administratorem.',
          label: 'Wybierz metodę weryfikacji',
          next: 'Dalej',
          pendingHint: 'Oczekiwanie na zatwierdzenie przez administratora',
          sms: 'SMS',
          title: 'Weryfikacja',
        },
        optional: {
          hint: 'Weryfikacja danych użytkownika da Ci pełny dostęp do zlecenia',
          label: 'Czy chcesz zweryfikować swoje dane?',
          next: 'Dalej',
          no: 'Nie',
          noHint:
            'Nie chcę weryfikować swoich danych i kontynuować z ograniczonym dostępem do zlecenia',
          title: 'Weryfikacja',
          yes: 'Tak',
          yesHint: 'Chcę zweryfikować swoje dane i uzyskać pełny dostęp do zlecenia',
        },
        sent: {
          description:
            'Link do logowania został wysłany na {identifier}. Kliknij link, aby dokończyć logowanie.',
          title: 'Link do logowania wysłany',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Wczoraj',
      today: 'Dzisiaj',
      days: {
        monday: 'Poniedziałek',
        tuesday: 'Wtorek',
        wednesday: 'Środa',
        thursday: 'Czwartek',
        friday: 'Piątek',
        saturday: 'Sobota',
        sunday: 'Niedziela',
      },
      months: {
        january: 'Styczeń',
        february: 'Luty',
        march: 'Marzec',
        april: 'Kwiecień',
        may: 'Maj',
        june: 'Czerwiec',
        july: 'Lipiec',
        august: 'Sierpień',
        september: 'Wrzesień',
        october: 'Październik',
        november: 'Listopad',
        december: 'Grudzień',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Coś poszło nie tak',
      message: 'Spróbuj ponownie zeskanować kod QR.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Nieznany użytkownik',
      },
      none: 'Brak',
      types: {
        stateTransition: 'Zmieniono status',
        contractorAssigned: 'Przypisano wykonawcę',
        engineerAssigned: 'Przypisano inżyniera',
        serviceAssigned: 'Przypisano usługę',
        priorityChanged: 'Zmieniono priorytet',
        actionableDateChanged: 'Zmieniono datę działania',
        dueDateChanged: 'Zmieniono termin',
        etaDateChanged: 'Zmieniono przewidywany czas przyjazdu',
        spendLimitApproved: 'Zatwierdzono limit wydatków',
        spendLimitCancelled: 'Anulowano wniosek o limit wydatków',
        spendLimitRejected: 'Odrzucono limit wydatków',
        spendLimitRequested: 'Wysłano wniosek o limit wydatków',
        jobSheetUploaded: 'Przesłano kartę pracy',
        slaAlertSent: 'Przekroczono czas SLA',
        issuedWorkPermit: 'Wydano pozwolenie na pracę',
        requestForServiceSent: 'Wysłano prośbę o usługę',
        comment: 'Dodano komentarz',
        unknown: 'Nieznane zdarzenie',
      },
      labels: {
        actionableDate: 'Data działania',
        comment: 'Komentarz',
        file: 'Plik',
        contractor: 'Wykonawca',
        dueDate: 'Termin',
        etaDate: 'Przewidywany czas przyjazdu',
        engineer: 'Inżynier',
        priority: 'Priorytet',
        requestForService: 'Prośba o usługę',
        service: 'Usługa',
        spendLimit: 'Limit wydatków',
        status: 'Status',
        workPermit: 'Pozwolenie na pracę',
      },
    },
  },
}
